import type { RootState } from 'reducers/types';
import type { FEATURES } from '../../constants';

type Features = (typeof FEATURES)[number];

export const getFeatures = (state: RootState) => {
  const { features = {} } = state;

  return features;
};

export const getFeature = (state: RootState, feature: Features): boolean => {
  const features = getFeatures(state);

  return Object.hasOwn(features, feature) ? !!features[feature] : false;
};
